import React from 'react';

const SidebarWidthContext = React.createContext('15%'); // default value

export default SidebarWidthContext;